import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=6db2157e&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"
import style0 from "./SankeyChart.vue?vue&type=style&index=0&id=6db2157e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2157e",
  null
  
)

export default component.exports